<div *ngIf="filtroArea==0" class="contenedor-full" [attr.data-isFulllView]='isPanelView'>
    <div class="blue-background"></div>
    <div class="top-divs" style="display: none;">
        <div class="top-div"
            style="flex: 1 1 0; height: 56px; padding: 16px; background: #0161BC; border-radius: 10px; overflow: hidden; border: 2px #2A529F solid; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
            <div class="Celebration" style="width: 24px; height: 24px; position: relative">
                <div class="BoundingBox"
                    style="width: 24px; height: 24px; left: 0px; top: 0px; position: absolute; background: #D9D9D9">
                </div>
                <div class="Celebration"
                    style="width: 20.62px; height: 19.57px; left: 2.63px; top: 1.80px; position: absolute; background: white">
                </div>
            </div>
            <div class="Content"
                style="flex: 1 1 0; flex-direction: column; justify-content: center; align-items: flex-start; gap: 4.83px; display: inline-flex">
                <div class="Label"
                    style="align-self: stretch; color: white; font-size: 20px; font-family: Montserrat; font-weight: 700; word-wrap: break-word">
                    Este mensaje personalizado es de máximo 55 caracteresss</div>
            </div>
        </div>
        <div class="top-div"
            style="flex: 1 1 0; height: 56px; padding: 16px; background: #0161BC; border-radius: 10px; overflow: hidden; border: 2px #2A529F solid; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
            <div class="NotificationsActive" style="width: 24px; height: 24px; position: relative">
                <div class="BoundingBox"
                    style="width: 24px; height: 24px; left: 0px; top: 0px; position: absolute; background: #D9D9D9">
                </div>
                <div class="NotificationsActive"
                    style="width: 19.91px; height: 20px; left: 2.04px; top: 2px; position: absolute; background: white">
                </div>
            </div>
            <div class="Content"
                style="flex: 1 1 0; flex-direction: column; justify-content: center; align-items: flex-start; gap: 4.83px; display: inline-flex">
                <div class="Label"
                    style="align-self: stretch; color: white; font-size: 20px; font-family: Montserrat; font-weight: 700; word-wrap: break-word">
                    Este mensaje personalizado es de máximo 55 caracteresss</div>
            </div>
        </div>
    </div>
    <div class="main-content">
        <panel-surtidor-container [ngClass]="['side-div']" (aExpanded)="toggleAnimationLeft($event)"
            [@expandedAnimationLeft]="stateExpandedLeft" [position]="leftClass" [surtidor]="surtidor_left"
            [sellerPanelReader]="lector_left" [isLive]="isLive" [isDebug]="isDebug" [clienteError]="clienteErrorLeft"
            [isDisabled_column]="isDisabled_left_column" [mqttError]="mqttError" [lector]="lector_left"
            [dataCliente]="dataClienteLeft">
        </panel-surtidor-container>
        <panel-grid-item-container [ngClass]="['center-div']" [@expandedAnimationCenter]="stateExpandedCenter"
            [offersQuantity]="cantidadOfertas" [alertsQuantity]="cantidadAlertas"
            [promotionAlertsLastQuantity]="lastAlertasPromos" [promotionAlerts]="source">
        </panel-grid-item-container>
        <panel-surtidor-container [ngClass]="['side-div']" (aExpanded)="toggleAnimationRight($event)"
            [@expandedAnimationRight]="stateExpandedRight" [position]="rightClass" [surtidor]="surtidor_right"
            [sellerPanelReader]="lector_right" [isLive]="isLive" [isDebug]="isDebug" [clienteError]="clienteErrorRight"
            [isDisabled_column]="isDisabled_right_column" [mqttError]="mqttError" [lector]="lector_right"
            [dataCliente]="dataClienteRight">
        </panel-surtidor-container>
    </div>
    <div class="bottom-divs" style="display: none;">
        <div class="bottom-div"
            style="flex: 1 1 0; height: 56px; padding: 16px; background: #C42D2D; border-radius: 10px; overflow: hidden; border: 2px #AB2020 solid; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
            <div class="Warning" style="width: 24px; height: 24px; position: relative">
                <div class="BoundingBox"
                    style="width: 24px; height: 24px; left: 0px; top: 0px; position: absolute; background: #D9D9D9">
                </div>
                <div class="Warning"
                    style="width: 20.53px; height: 18px; left: 1.74px; top: 3px; position: absolute; background: white">
                </div>
            </div>
            <div class="Content"
                style="flex: 1 1 0; flex-direction: column; justify-content: center; align-items: flex-start; gap: 4.83px; display: inline-flex">
                <div class="Label"
                    style="align-self: stretch; color: white; font-size: 20px; font-family: Montserrat; font-weight: 700; word-wrap: break-word">
                    Las alertas deben tener de máximo 55 caracteresssssssss</div>
            </div>
        </div>
        <div class="bottom-div"
            style="flex: 1 1 0; height: 56px; padding: 16px; background: #C42D2D; border-radius: 10px; overflow: hidden; border: 2px #AB2020 solid; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
            <div class="Cancel" style="width: 24px; height: 24px; position: relative">
                <div class="BoundingBox"
                    style="width: 24px; height: 24px; left: 0px; top: 0px; position: absolute; background: #D9D9D9">
                </div>
                <div class="Cancel"
                    style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute; background: white"></div>
            </div>
            <div class="Content"
                style="flex: 1 1 0; flex-direction: column; justify-content: center; align-items: flex-start; gap: 4.83px; display: inline-flex">
                <div class="Label"
                    style="align-self: stretch; color: white; font-size: 20px; font-family: Montserrat; font-weight: 700; word-wrap: break-word">
                    Las alertas deben tener de máximo 55 caracteresssssssss</div>
            </div>
        </div>
    </div>
</div>
<div class="no-soported-navigator" *ngIf="filtroArea==0 && detectIE<12">
    <div class="no-soported-navigator__icon">
        <span class="glyphicon glyphicon-ban-circle"></span>
    </div>
    <div class="no-soported-navigator__message">
        <span>Lo sentimos, no se puede visuzalizar el panel en este navegador</span>
    </div>
</div>
<div class="mensaje" *ngIf="filtroArea>0">
    <div>
        <span class="glyphicon glyphicon-ban-circle"></span>
    </div>
    <div>
        <p>
            El panel <span *ngIf="filtroArea==1">Tienda</span>
            <span *ngIf="filtroArea==2">Boxes</span> a&#250;n
            <strong>no est&#225; disponible</strong>
        </p>
    </div>
</div>